import React, { useState } from 'react';
import HeaderTabBarLayout from '../layouts/HeaderTabBarLayout';
import PartnerPlaceContainer from './PartnerPlaceContainer';
import KakaoPlaceContainer from './KakaoPlaceContainer';
import SelfPlaceContainer from './SelfPlaceContainer';

const TABS = [
    { id: 'partner', name: '제휴 매장' },
    { id: 'kakao', name: '주변 검색' },
    { id: 'self', name: '직접 입력' },
];

const PlaceSelectionContainer = ({ 
    title = '장소 선택',
    onPlaceSelect, 
    onBack,
    previousPlace 
}) => {
    const [activeTab, setActiveTab] = useState('partner');

    const handlePlaceSelect = (place) => {
        if (onPlaceSelect) {
            onPlaceSelect(place);
        }
    };

    const renderContent = () => {
        switch (activeTab) {
            case 'partner':
                return <PartnerPlaceContainer onPlaceSelect={handlePlaceSelect} />;
            case 'kakao':
                return <KakaoPlaceContainer onPlaceSelect={handlePlaceSelect} />;
            case 'self':
                return <SelfPlaceContainer onPlaceSelect={handlePlaceSelect} />;
            default:
                return null;
        }
    };

    return (
        <HeaderTabBarLayout
            title={title}
            tabs={TABS}
            activeTab={activeTab}
            onTabChange={setActiveTab}
            onBack={onBack}
        >
            {renderContent()}
        </HeaderTabBarLayout>
    );
};

export default PlaceSelectionContainer; 